<template>
  <v-dialog v-model="dialog" persistent max-width="800px" @keydown.esc="onDlgCancelClick">
    <v-card>
      <v-card-title class="popup-header">
        <span class="headline">工程登録</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col class="py-0" cols="6" sm="6" md="6">

              <v-select
                  :items="processesList"
                  label="大分類"
                  item-text="processGroupName"
                  item-value="processGroupCd"
                  :return-object="true"
                  v-model="selectedProcessGroup"
              >
              </v-select>

            </v-col>

          </v-row>
          <v-row>

            <v-col>
              <!-- 工程リスト -->
              <v-checkbox v-for="obj in selectedProcessesList"
                        :label="obj.processName"
                        :value="obj.processCd"
                        :key="obj.processCd"
                          v-model="process_cds"
                          dense
                        class="my-0 py-0"
              ></v-checkbox>
            </v-col>

            <v-col>
              <!-- 対応サイズ -->
              <p v-if="!!sizeSet && sizeSet.length > 0">対応サイズ</p>
              <v-container class="my-0 py-0">
                <v-row v-for="procSizeItem in sizeSet" :key="procSizeItem.sizeCd" class="my-0 py-0">
                  <v-col class="my-0 py-0">
                    <template v-if="procSizeItem.useRange == 1" >
                      <v-container  class="my-0 py-0">
                        <v-row no-gutters style="flex-wrap: nowrap;"  class="my-0 py-0">
                          <v-col cols="5" class="flex-grow-1 flex-shrink-0">
                            <v-text-field
                                :label="procSizeItem.sizeName"
                                v-model.number="sizeValuesMin[procSizeItem.sizeCd]"
                                :suffix="procSizeItem.unit"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="1" class="flex-grow-0 flex-shrink-1 pt-4 pl-2 pr-2">
                            <span>〜</span>
                          </v-col>
                          <v-col cols="5" class="flex-grow-1 flex-shrink-0">
                            <v-text-field
                                :label="procSizeItem.sizeName"
                                v-model.number="sizeValuesMax[procSizeItem.sizeCd]"
                                :suffix="procSizeItem.unit"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                    <template v-else>
                      <v-container  class="my-0 py-0">
                        <v-row  class="my-0 py-0">
                          <v-col>
                            <v-text-field
                                :label="procSizeItem.sizeName"
                                v-model.number="sizeValuesMin[procSizeItem.sizeCd]"
                                :suffix="procSizeItem.unit"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                  </v-col>
                </v-row>
              </v-container>



            </v-col>
          </v-row>
          <!--
                                 <template slot="selection" slot-scope="data">
                                    // HTML that describe how select should render selected items
                                    {{ data.item.name }} - {{ data.item.description }}
                                  </template>
                                  <template slot="item" slot-scope="data">
                                    // HTML that describe how select should render items when the select is open
                                    {{ data.item.name }} - {{ data.item.description }}
                                  </template>
             -->

          <v-row>
            <v-col class="py-0">
              <v-select

                  :items="materials"
                  label="対応素材"
                  multiple
                  chips
                  item-text="materialName"
                  item-value="materialCd"
                  v-model="materialCodes"
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="py-0">
              <v-select

                  :items="materialFaces"
                  label="対応母材"
                  multiple
                  chips
                  item-text="faceName"
                  item-value="faceCd"
                  v-model="materialFaceCodes"
              ></v-select>
            </v-col>
          </v-row>


          <v-row>
            <v-col class="py-0">
              <span>タグ</span>
              <v-text-field label="" v-model="tagInput" append-icon="mdi-tag-plus" @click:append="onAppendTag"
                            persistent-hint hint="利用する設備や特徴・アピールポイントを入力"></v-text-field>
            </v-col>
            <v-col class="py-0">
              (ここによく使われるタグを表示)
            </v-col>
          </v-row>

          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-chip-group column>
                <v-chip v-for="tag in editData.tags" :key="tag" close> {{ tag }}</v-chip>
              </v-chip-group>
            </v-col>
          </v-row>

        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="secondary" text @click.native="onDlgDeleteClick">削除</v-btn>
        <div class="flex-grow-1"></div>
        <v-btn color="primary" @click.native="onDlgSaveClick">追加</v-btn>
        <v-btn color="grey lighten-2" @click.native="onDlgCancelClick">キャンセル</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import BaseView from "../../components/BaseView";

export default {
  mixins: [BaseView],
  components: {},
  props: {},
  data: () => ({
    isInitialized: false,
    isFetched: false,
    isLoading: false,
    isDownloading: false,

    dialog: false,
    resolve: null,
    reject: null,

    supplierId: "",
    processId: "",

    errors: {},

    options: {
      color: 'primary',
      width: 290
    },

    tagInput: "",
    selectedProcessGroup: {
      processGroupName: "",
      processGroupCd: "",
      processings: [       
      ]
    },

    editData: {
      processGroupCd: "",
      processGroupName: "",
      tags: [],
      materials: [],
      materialFaces: [],
      sizeSet: [],
      processes: [],      
    },

    process_cds:[],

    sizeValuesMin:{
      height:0,
      width:0,
      depth:0,
    },
    sizeValuesMax:{
      height:0,
      width:0,
      depth:0,
    },

    materialCodes:[],
    materialFaceCodes:[],

    processesList: [
      {divider: true,},
      {
        header: "表面処理",
        sectionHeader: true,
        disabled: false,
      },
      {
        divider: true,
      },
      {
        name: "メッキ",
        id: "1",
        sizeSet: [
          {
            itemId: "width", name: "幅", unit: "mm",
          },
          {
            itemId: "height", name: "高さ", unit: "mm",
          },
          {
            itemId: "depth", name: "奥行", unit: "mm",
          },
          {
            itemId: "weight", name: "重量", unit: "kg",
          },
        ],        
      },
      
    ],


  }),
  computed: {
    // Vuex.Storeのデータ参照
    materials: function (){
      return this.$store.state.materials;
    },
    materialMap: function (){
      return this.$store.state.materialMap;
    },
    materialFaces: function (){
      return this.$store.state.materialFaces;
    },
    materialFaceMap: function (){
      return this.$store.state.materialFaceMap;
    },

    processMap: function (){
      return this.$store.state.processings.processMap;
    },

    rootProcessGroups:function (){
      return this.$store.state.processings.rootGroupTree;
    },

    selectedProcessesList: function () {
      if (!!this.selectedProcessGroup) {
        return this.selectedProcessGroup.processings;
      } else {
        return [];
      }
    },

    sizeSet: function () {
      if (this.selectedProcessGroup) {
        return this.selectedProcessGroup.sizeItems;
      } else {
        return [];
      }
    },

    process_groups: function () {
      return this.$store.state.processings.groups;
    },

    processGroupMap: function () {
      return this.$store.state.processings.groupMap;
    },


  },
  mounted: function () {
    this.setupConditions();
    this.fetchData(false);

  },
  created: function () {
  },
  watch: {
    '$route': function (to, from) {
      this.setupConditions();
    },
  },
  methods: {
    setupConditions() {
      this.editData.selected_group = null;
    },

    fetchData(needDataFetch) {
      let self = this;
      if (!this.isInitialized) {
        this.fetchBasicData(function () {
          self.fetchData(needDataFetch)
        });
        return;
      }
      if (needDataFetch) {
        this.isLoading = true;
        Promise.resolve()
            .then(data => {
              //
            })
            .catch(function (err) {
              console.log(err);
              self.showErrorToast("データの取得に失敗しました。");
            });
      }
    },

    fetchBasicData(finishProc) {
      this.isInitialized = true;


      console.log("rootProcessGroups",this.rootProcessGroups);

      this.processesList.splice(0)

      this.rootProcessGroups.forEach(rootGrp => {

        this.processesList.push({divider: true})

        if (rootGrp.processGroups){

          this.processesList.push({
            header: rootGrp.processGroupName,
            sectionHeader: true,
            disabled: false,
          })
          
          rootGrp.processGroups.forEach(cGrp => {
            this.processesList.push(cGrp)
          })

        } 
        
      })

      if (finishProc) {
        finishProc();
      }
    },


    open(supplierId, processId, data, options) {

      this.supplierId = supplierId;
      this.processId = processId;


      this.editData = Object.assign(this.editData, data);
      this.options = Object.assign(this.options, options); // 使っていないけど一応

      // 工程グループを選択させる
      let pgm = this.processGroupMap[this.editData.processGroupCd];
      this.selectedProcessGroup = pgm

      // 工程コードのリスト
      this.process_cds.splice(0);
      let cds = this.editData.processes.map(a => a.processCd);
      cds.forEach(cd => this.process_cds.push(cd) );

      // 対応サイズを設定する
      this.editData.availableSizes.forEach( ss => {
        this.sizeValuesMin[ss.itemCd] = ss.value1;
        this.sizeValuesMax[ss.itemCd] = ss.value2;
      });

      // 材質コードの準備
      this.materialCodes.splice(0);
      this.editData.materials.forEach(m => {
        this.materialCodes.push(m.materialCd)
      });


      // 母材形状の準備
      this.materialFaceCodes.splice(0)
      this.editData.materialFaces.forEach(mf => {
        this.materialFaceCodes.push(mf.materialFaceCd)
      })


      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    // 保存ボタン押下
    onDlgSaveClick() {
      //this.$emit("save")

      let groupCd = this.selectedProcessGroup.processGroupCd;

      // 工程グループCDの設定
      this.editData.processGroupCd = groupCd;
      this.editData.processGroupName = this.selectedProcessGroup.processGroupName; //this.processGroupMap[groupCd].name;



      //let proc = this.processMap[this.editData.process_cd];
      //if (proc){
      //  this.editData.process_name = proc.name
      //} else {
      //  console.log("工程情報が見つかりませんでした。CD:" + this.editData.process_cd)
      //  console.log("this.processMap", this.processMap)
      //  this.editData.process_name = ""
      //}

      //工程の追加
      console.log("this.processMap", this.processMap)
      console.log("this.process_cds", this.process_cds)
      this.editData.processes.splice(0)
      this.process_cds.forEach(cd =>{
        let proc = this.processMap[cd];
        let procName = ""
        if (proc){
          procName = proc.processName
        } else {
          console.log("工程情報が見つかりませんでした。CD:" + cd)          
        }
        this.editData.processes.push({
          processCd:cd,
          processGroupCd:groupCd,
          processName:procName,
        });
      });

      // 材料の設定
      this.editData.materials.splice(0)
      console.log("materialCodes",this.materialCodes)
      this.materialCodes.forEach(cd => {
        let m = this.materialMap[cd];
        if (m){
          this.editData.materials.push({
            materialCd:m.materialCd,
            materialName:m.materialName
          })
        } else {
          console.log("材質が見つかりませんでした。CD:" + cd)
          console.log("materialMap" ,this.materialMap)      
        }
      })

      // 母材形状の設定
      this.editData.materialFaces.splice(0)
      console.log("materialFaceCodes",this.materialFaceCodes)
      this.materialFaceCodes.forEach(cd => {
        let m = this.materialFaceMap[cd];
        if (m){
          this.editData.materialFaces.push({
            materialFaceCd:cd,
            materialFaceName:m.faceName
          })
        } else {
          console.log("母材形状が見つかりませんでした。CD:" + cd)     
          console.log("materialFaceMap" ,this.materialFaceMap)  
        }
      })

      // サイズセットの設定
      this.editData.availableSizes.splice(0)
      console.log("sizeset",this.sizeSet)
      this.sizeSet.forEach(ss => {

        let sizeRec = {
          itemCd:ss.sizeCd,
          name:ss.sizeName,
          unit:ss.unit,
          useRange:ss.useRange,
          value1:this.sizeValuesMin[ss.sizeCd],
          value2:this.sizeValuesMax[ss.sizeCd],
        };

        this.editData.availableSizes.push(sizeRec)
      });


      console.log("onDlgSaveClick editData",this.editData)

      this.resolve([1, Object.assign({}, this.editData)]);
      this.dialog = false;
    },

    onDlgCancelClick() {
      this.resolve(null);
      this.dialog = false;
    },

    onDlgDeleteClick() {

      let self = this;

      /*
      Promise.resolve()
          .then(a => { return this.checkAuthToken() })
          .then(a => { return ReportCommentAPI.deleteComment(this.commentId) })
          .then(response => {
              this.resolve([9,""]);
              this.dialog = false;
          })
          .catch(function(err) {
              console.log(err);
              self.showErrorToast("データの更新に失敗しました。");
          });
      */
    },


    onAppendTag() {
      if (this.tagInput) {
        let name = this.tagInput
        //console.log(name)
        this.editData.tags.push(name);
      }
      this.tagInput = "";
    },
  },

}
</script>